import { Info, LogOut, MessageSquarePlus, Settings } from "lucide-react";
import type { SidebarAccountMenuItem } from "./SidebarAccountMenu";
import type { SidebarNavLabels, SidebarNavProps } from "./SidebarNav";

/** The account menu's entries, in order: Settings, Send feedback, About, then Sign out (each but Settings when the app has it). */
export function accountMenuItems({
  onOpenProfile,
  onOpenFeedback,
  onOpenAbout,
  onSignOut,
  labels: l,
}: Pick<SidebarNavProps, "onOpenProfile" | "onOpenFeedback" | "onOpenAbout" | "onSignOut"> & {
  labels: Pick<SidebarNavLabels, "settings" | "feedback" | "about" | "signOut">;
}): SidebarAccountMenuItem[] {
  const items: SidebarAccountMenuItem[] = [
    { key: "settings", label: l.settings, icon: <Settings size={16} />, onSelect: onOpenProfile },
  ];
  if (onOpenFeedback) {
    items.push({
      key: "feedback",
      label: l.feedback,
      icon: <MessageSquarePlus size={16} />,
      onSelect: onOpenFeedback,
      opensDialog: true,
    });
  }
  if (onOpenAbout) {
    items.push({
      key: "about",
      label: l.about,
      icon: <Info size={16} />,
      onSelect: onOpenAbout,
      opensDialog: true,
    });
  }
  if (onSignOut) {
    items.push({
      key: "signOut",
      label: l.signOut,
      icon: <LogOut size={16} />,
      onSelect: onSignOut,
      separatorBefore: true,
    });
  }
  return items;
}
